import React, { useState } from "react";
import { Dropdown, Button } from "antd";
import { setLocale, getCurrentLocale } from "./locales";
import { RiEmphasisCn, RiEnglishInput } from "react-icons/ri";

const languageOptions = [
    { code: "en", label: "English", icon: <RiEnglishInput style={{ marginRight: 6 }} /> },
    { code: "zh", label: "中文", icon: <RiEmphasisCn style={{ marginRight: 6 }} /> },
];

interface LanguageSelectDropdownProps {
    onChange?: (locale: string) => void;
}

const LanguageSelectDropdown: React.FC<LanguageSelectDropdownProps> = ({ onChange }) => {
    const [locale, setLocaleState] = useState(getCurrentLocale());

    const handleChange = (code: string) => {
        setLocale(code as "en" | "zh");
        setLocaleState(code);
        onChange?.(code);

        // 强制刷新页面
        window.location.reload();
    };

    const currentLang = languageOptions.find((l) => l.code === locale);

    // antd Dropdown menu items
    const items = languageOptions.map((lang) => ({
        key: lang.code,
        label: (
            <div
                style={{ display: "flex", alignItems: "center" }}
                onClick={() => handleChange(lang.code)}
            >
                {lang.icon}
                {lang.label}
            </div>
        ),
    }));

    return (
        <Dropdown menu={{ items }} placement="bottomRight" trigger={["click"]}>
            <Button
                size="small"
                style={{
                    display: "flex",
                    alignItems: "center",
                }}
            >
                {currentLang?.icon}
                {currentLang?.label || "Language"}
            </Button>
        </Dropdown>
    );
};

export default LanguageSelectDropdown;
